export const LOCATION_SHARING_OPT_IN_KEY = '@eleplan/location_sharing_opt_in';
